import { AxiosResponse } from "axios";

import { painelApi } from "../painelApi";

const PATH_IMPORT_SQL = "/v1/import/sql";

export async function uploadArquivo(file: File): Promise<AxiosResponse<any>> {
  const formData = new FormData();
  formData.append("file", file);

  return await painelApi.post(PATH_IMPORT_SQL, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}
